import {
    SkyNetTableConfig, RangeType, SkyNetTableField, injectFieldsToTabs,
} from 'app/shared-components/SkyNetTable'
import {
    FilterType,
    CommonRoutes,
} from 'app/enums/common.enums'
import {
    SkyNetTableTab,
} from 'app/shared-components/SkyNetTable/types/skyNetTable.types'

import {
    LoggerStatus, LoggerMode,
} from 'app/enums/label.enums'
import {
    convertFromFilterDaysDate,
    convertToFilterDaysDate,
    parseFromFilterDaysDate,
    parseToFilterDaysDate,
} from 'app/utils/date'

import LoggerType, {
    LoggerTable,
} from './Loggers.types'

const nameColumn: SkyNetTableField<keyof LoggerTable>[] = [
    {
        name: 'loggerNumber',
        reduced: true,
        labelKey: 'LOGGER',
    },
    {
        name: 'loggerType',
        componentName: 'EnumValue',
        allowedValuesEnum: LoggerType,
        filterField: 'loggerType',
        filterType: FilterType.Array,
        labelKey: 'LOGGER_TYPE',
    },
]
const stateColumn: SkyNetTableField<keyof LoggerTable> = {
    name: 'loggerStatus',
    componentName: 'EnumValue',
    allowedValuesEnum: LoggerStatus,
    filterField: 'loggerStatus',
    filterType: FilterType.Array,
    labelKey: 'LOGGER_STATUS',
}
const otherColumns: SkyNetTableField<keyof LoggerTable>[] = [
    {
        name: 'loggerMode',
        componentName: 'EnumValue',
        allowedValuesEnum: LoggerMode,
        filterField: 'loggerMode',
        filterType: FilterType.Array,
        sorting: false,
        labelKey: 'LOGGER_MODE',
    },
    {
        name: 'locationName',
        filterField: 'locationName',
        filterType: FilterType.Array,
        labelKey: 'LAST_LOCATION',
    },
    {
        name: 'gatewayImeiMac',
        filterField: 'gatewayImeiMac',
        filterType: FilterType.Array,
        sorting: false,
        labelKey: 'GATEWAY_IMEI_MAC_ADDRESS',
    },
    {
        name: 'productionBatchNumber',
        filterField: 'productionBatchNumber',
        filterType: FilterType.Array,
        labelKey: 'BATCH_NUMBER',
    },
    {
        name: 'containerSerialNumber',
        sorting: false,
        labelKey: 'CONTAINER',
    },
    {
        name: 'isTestingLogger',
        filterField: 'isTestingLogger',
        filterType: FilterType.Array,
        componentName: 'ChipCheckMark',
        sorting: false,
        labelKey: 'IS_TESTING_LOGGER',
    },
    {
        name: 'lastMeasuredOnUtc',
        componentName: 'TemperatureAge',
        rangeType: RangeType.DayRange,
        filterField: 'lastMeasuredOnUtc',
        filterType: FilterType.IntegerRange,
        filterOptions: {
            labels: {
                from: 'More or Equal (Days)',
                to: 'Less Then (Days)',
            },
            convert: {
                from: convertFromFilterDaysDate,
                to: convertToFilterDaysDate,
            },
            parse: {
                from: parseFromFilterDaysDate,
                to: parseToFilterDaysDate,
            },
        },
        labelKey: 'MEASURED',
    },
    {
        name: 'batteryVoltage',
        sorting: false,
        labelKey: 'BATTERY_VOLTAGE_MV',
    },
    {
        name: 'hardwareVersion',
        filterField: 'hardwareVersion',
        filterType: FilterType.Array,
        labelKey: 'HARDWARE_VERSION',
    },
    {
        name: 'softwareVersion',
        filterField: 'softwareVersion',
        filterType: FilterType.Array,
        labelKey: 'SOFTWARE_VERSION',
    },
    {
        name: 'rentingCompany',
        sorting: false,
        filterField: 'rentingCompany',
        filterType: FilterType.Array,
        labelKey: 'RENTING_COMPANY',
    },
    {
        name: 'createdOn',
        componentName: 'LoggerAgeFromDate',
        labelKey: 'LOGGER_AGE',
        rangeType: RangeType.DayRange,
        filterField: 'createdOn',
        filterType: FilterType.IntegerRange,
        filterOptions: {
            labels: {
                from: 'More or Equal (Days)',
                to: 'Less Then (Days)',
            },
            convert: {
                from: convertFromFilterDaysDate,
                to: convertToFilterDaysDate,
            },
            parse: {
                from: parseFromFilterDaysDate,
                to: parseToFilterDaysDate,
            },
        },
    },
    {
        name: 'lastActivatedOn',
        componentName: 'LoggerLastActivated',
        labelKey: 'LAST_ACTIVATED_ON',
    },
]
const defaultFields: SkyNetTableField<keyof LoggerTable>[] = [
    ...nameColumn,
    ...[stateColumn],
    ...otherColumns,
]

const excludeTab: SkyNetTableTab<keyof LoggerTable> = {
    name: 'Excluded',
    url: CommonRoutes.Excluded,
    requestUrl: 'all',
    includeFilters: {
        loggerStatus: [LoggerStatus.DECOMMISSIONED],
    },
    fields: [
        ...nameColumn,
        ...otherColumns,
    ],
}

const config: SkyNetTableConfig<keyof LoggerTable> = {
    name: 'LoggersTable',
    tabs: injectFieldsToTabs<keyof LoggerTable>([
        {
            name: 'All Loggers',
            url: CommonRoutes.All,
            filters: {
                loggerStatusExcluded: [LoggerStatus.DECOMMISSIONED],
            },
        },
        excludeTab,
    ], defaultFields),
}

export default config
